<template>
    <div>
        <transition name="modal">
            <div class="modal" style="display: block">
                <div class="modal-dialog modal-lg" role="document">

                    <div class="modal-content">

                        <div class="modal-header  abtg__header-modal">


                            <h5 class="modal-title abtg__modal-title" id="exampleModalLabel2">{{$t('custom.label_modal_configure')}}</h5>

                            <div class="tools">
                                <div class="abtg__close-button"><a data-dismiss="modal"    @click="closeModal()" ><i class="fas fa-times"></i></a></div>

                            </div>


                        </div>
                        <div class="modal-body">

                            <div class="modal-body">

                                <!-- AGENZIA -->
                                <div class="row">
                                    <div class="col-12">
                                        <h5 class="abtg__readonly">Percentuale Agenzia Acquisto</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">

                                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"

                                        >
                                            <input class="mdl-textfield__input abtg__input"
                                                   name="percentage_estate_1"
                                                   type="text"
                                                   v-model="formData.percentage_estate_1"
                                                   v-money="money"
                                            >
                                            <label class="mdl-textfield__label">{{$t('custom.label_percentage_estate_better_scenario')}}</label>

                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"

                                        >
                                            <input class="mdl-textfield__input abtg__input"
                                                   name="percentage_estate_2"
                                                   type="text"
                                                   v-model="formData.percentage_estate_2"
                                                   v-money="money"
                                            >
                                            <label class="mdl-textfield__label">{{$t('custom.label_percentage_estate_middle_scenario')}}</label>

                                        </div>

                                    </div>
                                    <div class="col-3">
                                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"

                                        >
                                            <input class="mdl-textfield__input abtg__input"
                                                   name="percentage_estate_3"
                                                   type="text"
                                                   v-model="formData.percentage_estate_3"
                                                   v-money="money"
                                            >
                                            <label class="mdl-textfield__label">{{$t('custom.label_percentage_estate_worst_scenario')}}</label>

                                        </div>
                                    </div>

                                </div>

                                <!-- IMPOSTA SOSTITUTIVA-->
                                <div class="row">
                                    <div class="col-12">
                                        <h5 class="abtg__readonly">Percentuale Imposta Sotitutiva</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">

                                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"

                                        >
                                            <input class="mdl-textfield__input abtg__input"
                                                   name="percentage_estate_1"
                                                   type="text"
                                                   v-model="formData.substitutiveTax_1"
                                                   v-money="money"
                                            >
                                            <label class="mdl-textfield__label">{{$t('custom.label_percentage_estate_better_scenario')}}</label>

                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"

                                        >
                                            <input class="mdl-textfield__input abtg__input"
                                                   name="percentage_estate_2"
                                                   type="text"
                                                   v-model="formData.substitutiveTax_2"
                                                   v-money="money"
                                            >
                                            <label class="mdl-textfield__label">{{$t('custom.label_percentage_estate_middle_scenario')}}</label>

                                        </div>

                                    </div>
                                    <div class="col-3">
                                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"

                                        >
                                            <input class="mdl-textfield__input abtg__input"
                                                   name="percentage_estate_3"
                                                   type="text"
                                                   v-model="formData.substitutiveTax_3"
                                                   v-money="money"
                                            >
                                            <label class="mdl-textfield__label">{{$t('custom.label_percentage_estate_worst_scenario')}}</label>

                                        </div>
                                    </div>

                                </div>



                            </div>


                        </div>
                        <div class="modal-footer">
                            <button type="submit"
                                    data-dismiss="modal"
                                    @click="closeModal()"
                                    class="btn btn-success abtg__default-button abtg__btn-star"

                            >

                                SALVA E CHIUDI
                            </button>
                        </div>
                    </div>

                </div>
            </div>

        </transition>
    </div>
</template>


<script>

    import {mixin} from '../../helpers/helper'
    import {Money} from 'v-money';
    import {createHelpers} from 'vuex-map-fields';
    import saveOk from '../commons/saveok';

    const {mapFields} = createHelpers({
        getterType: 'customfreeauction/getField',
        mutationType: 'customfreeauction/updateField',
    });

    export default {
        mixins: [mixin],
        components: {Money, saveOk},
        data: function () {
            return {
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 1,
                    masked: false
                }
            }
        },

        computed: {
            ...mapFields(['formData', 'inputs']),
        },
        created: function () {
        },
        methods: {
            closeModal: function () {
                this.$parent.showHideModalConfigure();
            },


        }
    }
</script>